import { useState, useEffect } from "react";
import ReactTimeago from "react-timeago-i18n";
import {
  Group,
  Container,
  Text,
  Grid,
  Stack,
  Badge,
  NumberFormatter,
  Pagination,
} from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import PlaygroundBulkEditor from "./PlaygroundBulkEditor";
import PlaygroundBulkDetails from "./PlaygroundBulkDetails";
import SelectCard from "../../_Common/SelectedCard";
import { useBulkStore } from "./store";

export default function PlaygroundBulkPage() {
  const selectedBulkCall = useBulkStore((state) => state.selectedBulkCall);
  const setSelectedBulkCall = useBulkStore(
    (state) => state.setSelectedBulkCall
  );
  const [activePage, setActivePage] = useState(1);

  const { loadPage, callsPaginated } = useBulkStore();
  const pageSize = 8;

  useEffect(() => {
    loadPage(activePage, pageSize);
  }, [activePage, loadPage]);

  return (
    <Container size="lg">
      <Grid justify="space-between">
        <Grid.Col span={3}>
          <Stack gap="xs">
            <SelectCard
              selected={selectedBulkCall == null}
              onClick={() => {
                setSelectedBulkCall(null);
              }}
            >
              <Group justify="space-between">
                <Text fw={500}>New</Text>
                <IconPlus size={16} />
              </Group>
            </SelectCard>
            <Pagination
              total={Math.ceil(callsPaginated.totalCount / pageSize)}
              value={activePage}
              size="xs"
              onChange={setActivePage}
            />
            {callsPaginated.data?.map((call) => (
              <SelectCard
                key={call.id}
                onClick={() => {
                  setSelectedBulkCall(call);
                }}
                selected={selectedBulkCall == call}
              >
                <Group justify="space-between">
                  <Text fz="sm" fw={500}>
                    <ReactTimeago date={call.idCreated} />
                  </Text>
                  <Text fz="xs">
                    <NumberFormatter
                      value={call.totalCost * 100}
                      decimalScale={2}
                      suffix="¢"
                    />
                  </Text>
                </Group>
                <Text lineClamp={2} c="dimmed" fz="xs">
                  {call.prompt}
                </Text>
                {call.models?.map((p) => (
                  <Badge
                    color="grape"
                    variant="light"
                    radius="xs"
                    mr="xs"
                    key={call.id + "mod" + p}
                    size="xs"
                  >
                    {p}
                  </Badge>
                ))}
              </SelectCard>
            ))}
          </Stack>
        </Grid.Col>

        <Grid.Col span={9}>
          {selectedBulkCall ? (
            <PlaygroundBulkDetails />
          ) : (
            <PlaygroundBulkEditor />
          )}
        </Grid.Col>
      </Grid>
    </Container>
  );
}
